import { Container, Eyebrow, Section, Reveal } from "./common";
import { CARBONO } from "../data/content";

export const RaizCarbono = () => {
  return (
    <Section id="carbono">
      <Container>
        <Reveal>
          <Eyebrow>Raíz Carbono · El brazo técnico-ambiental</Eyebrow>
          <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
            El impacto, <span className="text-rc-sage italic">verificado</span>
          </h2>
          <p className="mt-6 max-w-3xl text-stone-400 font-light leading-relaxed">
            Raíz Carbono no vende promesas de carbono. Mide, planea y verifica el desempeño ambiental del
            territorio con estándares reconocidos — para que el resultado sea legible ante los marcos que el
            capital ya usa (TNFD) y elegible para los créditos combinados de carbono y biodiversidad.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {CARBONO.map((c, i) => (
            <Reveal key={c.code} delay={i * 0.1}>
              <div className="h-full p-8 rounded-2xl bg-rc-card border border-rc-border hover:border-rc-sage/40 transition-all duration-300">
                <div className="font-mono text-sm text-rc-terra tracking-widest">{c.code}</div>
                <h3 className="mt-5 font-serif text-xl text-stone-100">{c.title}</h3>
                <p className="mt-3 text-stone-400 font-light leading-relaxed">{c.text}</p>
                <div className="mt-6 pt-4 border-t border-rc-border text-xs font-mono text-rc-sage/80">
                  {c.std}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 max-w-3xl font-serif text-lg font-light leading-relaxed text-stone-300 border-l-2 border-rc-sage/50 pl-6">
            El bono de carbono <span className="text-stone-100">no es la puerta de entrada</span> — es el
            dividendo que llega cuando la arquitectura ya funciona y el impacto es medible. Primero se
            construye la gobernanza y el sistema; la verificación viene después.
          </p>
        </Reveal>
      </Container>
    </Section>
  );
};
